import styled from 'styled-components'
// theme
import { colors } from 'themes/index'

export const Link = styled.a`
  font-weight: 500;
  color: ${colors.blue300};
  font-size: 15px;
  cursor: pointer;
  text-decoration: none;
`

export const RelatedFormsContainer = styled.div`
  margin-top: 16px;
  display: grid;
  grid-template-columns: 1fr 0.2fr 0.2fr;
  gap: 12px;
`

export const FormFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const UsersWrapper = styled.div`
  grid-column: span 3;
`

export const SwitchWrapper = styled.div`
  grid-column: span 3;
`
